import {
  AlertTriangle,
  BarChart3,
  Briefcase,
  Building2,
  CheckCircle2,
  ChevronDown, ChevronRight,
  Clock,
  Download,
  FileCheck,
  Film,
  Stethoscope,
  Users,
  Wrench
} from 'lucide-react';
import { useMemo, useState } from 'react';

const GENERATOR_CONFIG = {
  QualiopiPDF: {
    label:      'Qualiopi',
    color:      'emerald',
    icon:       FileCheck,
    badgeText:  'RNQ',
    metrics: (data) => [
      { icon: Users,    label: 'Inscrits',      value: data.apprenants?.totalInscrits ?? 0,
        sub: `${data.apprenants?.certifies ?? 0} certifiés (${data.apprenants?.tauxCertification ?? 0}%)` },
      { icon: Clock,    label: 'Temps moyen',   value: `${data.apprenants?.tempsMoyenHeures ?? 0}h`,
        sub: `Total : ${data.apprenants?.tempsTotalHeures ?? 0}h` },
      { icon: BarChart3,label: 'Quiz final',     value: data.evaluations?.scoreMoyenFinalQuiz != null ? `${data.evaluations.scoreMoyenFinalQuiz}%` : '—',
        sub: `Participation ${data.evaluations?.tauxParticipationQuiz ?? 0}%` },
      { icon: Users,    label: 'Actifs 7j',     value: data.assiduite?.actifs7jours ?? 0,
        sub: 'apprenants cette semaine' },
    ],
  },
  DPCPDF: {
    label:      'DPC',
    color:      'sky',
    icon:       Stethoscope,
    badgeText:  'DPC',
    metrics: (data) => [
      { icon: Users,    label: 'Professionnels', value: data.apprenants?.totalProfessionnels ?? 0,
        sub: `${data.apprenants?.totalHeuresDPC ?? 0}h DPC` },
      { icon: Clock,    label: 'Heures validées',value: `${data.apprenants?.totalHeuresValidees ?? 0}h`,
        sub: `sur ${data.apprenants?.totalHeuresDPC ?? 0}h` },
      { icon: BarChart3,label: 'Conformité 3 ans',value: `${data.obligation?.tauxConformite ?? 0}%`,
        sub: `${data.obligation?.conformes ?? 0}/${data.obligation?.total ?? 0}` },
      { icon: Users,    label: 'Actifs 7j',      value: data.assiduite?.actifs7jours ?? 0,
        sub: 'professionnels cette semaine' },
    ],
  },
  AfdasPDF: {
    label:      'AFDAS',
    color:      'fuchsia',
    icon:       Film,
    badgeText:  'AFDAS',
    metrics: (data) => [
      { icon: Users,    label: 'Intermittents',  value: data.intermittents?.total ?? 0,
        sub: `${data.intermittents?.heuresFinancees ?? 0}h financées` },
      { icon: BarChart3,label: 'Dossiers acceptés',value: data.intermittents?.dossiersAcceptes ?? 0,
        sub: `sur ${data.financementGlobal?.totalDossiers ?? 0}` },
      { icon: Clock,    label: 'Heures financées',value: `${data.financementGlobal?.totalHeuresFinancees ?? 0}h`,
        sub: 'total' },
      { icon: Users,    label: 'Actifs 7j',      value: data.assiduite?.actifs7jours ?? 0,
        sub: 'intermittents cette semaine' },
    ],
  },
  FifplPDF: {
    label:      'FIFPL',
    color:      'violet',
    icon:       Briefcase,
    badgeText:  'FIFPL',
    metrics: (data) => [
      { icon: Users,    label: 'Libéraux inscrits',value: data.apprenants?.totalInscrits ?? 0,
        sub: `${data.apprenants?.certifies ?? 0} attestations émises` },
      { icon: Clock,    label: 'Temps moyen',     value: `${data.apprenants?.tempsMoyenHeures ?? 0}h`,
        sub: `Total : ${data.apprenants?.tempsTotalHeures ?? 0}h` },
      { icon: BarChart3,label: 'Score moyen',     value: data.evaluations?.scoreMoyenFinalQuiz != null ? `${data.evaluations.scoreMoyenFinalQuiz}%` : '—',
        sub: `Seuil : ${data.evaluations?.seuilReussite ?? 70}%` },
      { icon: Users,    label: 'Actifs 7j',       value: data.assiduite?.actifs7jours ?? 0,
        sub: 'professionnels cette semaine' },
    ],
  },
  AktoPDF: {
    label:      'AKTO',
    color:      'cyan',
    icon:       Building2,
    badgeText:  'PDC',
    metrics: (data) => [
      { icon: Users,    label: 'Collaborateurs', value: data.apprenants?.totalInscrits ?? 0,
        sub: `${data.apprenants?.certifies ?? 0} validés PDC` },
      { icon: Clock,    label: 'Temps moyen',    value: `${data.apprenants?.tempsMoyenHeures ?? 0}h`,
        sub: `Total : ${data.apprenants?.tempsTotalHeures ?? 0}h` },
      { icon: BarChart3,label: 'Score moyen',    value: data.evaluations?.scoreMoyenFinalQuiz != null ? `${data.evaluations.scoreMoyenFinalQuiz}%` : '—',
        sub: `Participation ${data.evaluations?.tauxParticipationQuiz ?? 0}%` },
      { icon: Users,    label: 'Actifs 7j',      value: data.assiduite?.actifs7jours ?? 0,
        sub: 'collaborateurs cette semaine' },
    ],
  },
  AnfhPDF: {
    label:      'ANFH',
    color:      'teal',
    icon:       Stethoscope,
    badgeText:  'FPH',
    metrics: (data) => [
      { icon: Users,    label: 'Agents FPH',     value: data.apprenants?.totalInscrits ?? 0,
        sub: `${data.apprenants?.certifies ?? 0} attestations Plan Formation` },
      { icon: Clock,    label: 'Heures validées',value: `${data.apprenants?.tempsTotalHeures ?? 0}h`,
        sub: `Moy. ${data.apprenants?.tempsMoyenHeures ?? 0}h/agent` },
      { icon: BarChart3,label: 'Score moyen',    value: data.evaluations?.scoreMoyenFinalQuiz != null ? `${data.evaluations.scoreMoyenFinalQuiz}%` : '—',
        sub: `Seuil : ${data.evaluations?.seuilReussite ?? 70}%` },
      { icon: Users,    label: 'Actifs 7j',      value: data.assiduite?.actifs7jours ?? 0,
        sub: 'agents cette semaine' },
    ],
  },
  QualibatPDF: {
    label:      'Qualibat',
    color:      'amber',
    icon:       Wrench,
    badgeText:  'BTP',
    metrics: (data) => [
      { icon: Users,    label: 'Apprenants BTP', value: data.apprenants?.totalApprenantsBTP ?? 0,
        sub: `${data.apprenants?.certifiesQualibat ?? 0} certifiés` },
      { icon: Clock,    label: 'Progression',    value: `${data.apprenants?.progressionMoyenne ?? 0}%`,
        sub: 'moyenne' },
      { icon: BarChart3,label: 'Chantiers éligibles',value: data.chantiersEligibles ?? 0,
        sub: 'en cours' },
      { icon: Users,    label: 'Actifs 7j',      value: data.assiduite?.actifs7jours ?? 0,
        sub: 'apprenants BTP cette semaine' },
    ],
  },
  RGEPDF: {
    label:      'RGE',
    color:      'green',
    icon:       Wrench,
    badgeText:  'RGE',
    metrics: (data) => [
      { icon: Users,    label: 'Certifiés RGE',  value: data.certificationsRGE?.totalCertifies ?? 0,
        sub: `${data.certificationsRGE?.primesCumulees ?? 0}€ de primes` },
      { icon: BarChart3,label: 'Projets éligibles',value: data.projetsEligibles ?? 0,
        sub: 'en attente' },
      { icon: Clock,    label: 'Actifs 7j',      value: data.assiduite?.actifs7jours ?? 0,
        sub: 'professionnels cette semaine' },
      { icon: Users,    label: 'Renouvellements',value: data.renouvellements?.aVenir ?? 0,
        sub: `dans les 90 jours` },
    ],
  },
};

const DEFAULT_CONFIG = {
  label:    'Certifications',
  color:    'zinc',
  icon:     FileCheck,
  badgeText:'DOC',
  metrics: () => [],
};

// ─────────────────────────────────────────────────────────────────────────────
// PALETTE TAILWIND — classes complètes pour éviter la purge CSS
// ─────────────────────────────────────────────────────────────────────────────
const COLOR_CLASSES = {
  emerald: { border:'border-emerald-800', bg:'bg-emerald-950/20', text:'text-emerald-300', icon:'text-emerald-400', badge:'bg-emerald-900 text-emerald-300 border border-emerald-700', dot:'bg-emerald-500', btn:'bg-emerald-900/70 border-emerald-700 text-emerald-300 hover:bg-emerald-800 hover:border-emerald-600', ring:'ring-emerald-700' },
  sky:     { border:'border-sky-800',     bg:'bg-sky-950/20',     text:'text-sky-300',     icon:'text-sky-400',     badge:'bg-sky-900 text-sky-300 border border-sky-700',         dot:'bg-sky-500',     btn:'bg-sky-900/70 border-sky-700 text-sky-300 hover:bg-sky-800 hover:border-sky-600',         ring:'ring-sky-700' },
  fuchsia: { border:'border-fuchsia-800', bg:'bg-fuchsia-950/20', text:'text-fuchsia-300', icon:'text-fuchsia-400', badge:'bg-fuchsia-900 text-fuchsia-300 border border-fuchsia-700', dot:'bg-fuchsia-500', btn:'bg-fuchsia-900/70 border-fuchsia-700 text-fuchsia-300 hover:bg-fuchsia-800 hover:border-fuchsia-600', ring:'ring-fuchsia-700' },
  violet:  { border:'border-violet-800',  bg:'bg-violet-950/20',  text:'text-violet-300',  icon:'text-violet-400',  badge:'bg-violet-900 text-violet-300 border border-violet-700',   dot:'bg-violet-500',  btn:'bg-violet-900/70 border-violet-700 text-violet-300 hover:bg-violet-800 hover:border-violet-600',   ring:'ring-violet-700' },
  cyan:    { border:'border-cyan-800',    bg:'bg-cyan-950/20',    text:'text-cyan-300',    icon:'text-cyan-400',    badge:'bg-cyan-900 text-cyan-300 border border-cyan-700',         dot:'bg-cyan-500',    btn:'bg-cyan-900/70 border-cyan-700 text-cyan-300 hover:bg-cyan-800 hover:border-cyan-600',         ring:'ring-cyan-700' },
  teal:    { border:'border-teal-800',    bg:'bg-teal-950/20',    text:'text-teal-300',    icon:'text-teal-400',    badge:'bg-teal-900 text-teal-300 border border-teal-700',         dot:'bg-teal-500',    btn:'bg-teal-900/70 border-teal-700 text-teal-300 hover:bg-teal-800 hover:border-teal-600',         ring:'ring-teal-700' },
  amber:   { border:'border-amber-800',   bg:'bg-amber-950/20',   text:'text-amber-300',   icon:'text-amber-400',   badge:'bg-amber-900 text-amber-300 border border-amber-700',      dot:'bg-amber-500',   btn:'bg-amber-900/70 border-amber-700 text-amber-300 hover:bg-amber-800 hover:border-amber-600',      ring:'ring-amber-700' },
  green:   { border:'border-green-800',   bg:'bg-green-950/20',   text:'text-green-300',   icon:'text-green-400',   badge:'bg-green-900 text-green-300 border border-green-700',      dot:'bg-green-500',   btn:'bg-green-900/70 border-green-700 text-green-300 hover:bg-green-800 hover:border-green-600',      ring:'ring-green-700' },
  zinc:    { border:'border-zinc-700',    bg:'bg-zinc-900',       text:'text-zinc-400',    icon:'text-zinc-500',    badge:'bg-zinc-800 text-zinc-400 border border-zinc-700',          dot:'bg-zinc-600',    btn:'bg-zinc-800 border-zinc-700 text-zinc-400 hover:bg-zinc-700',                                   ring:'ring-zinc-700' },
};

function getCfg(generator) {
  return GENERATOR_CONFIG[generator] || DEFAULT_CONFIG;
}

function getColors(color) {
  return COLOR_CLASSES[color] || COLOR_CLASSES.zinc;
}

// ─────────────────────────────────────────────────────────────────────────────
// SOUS-COMPOSANT : badge générateur
// ─────────────────────────────────────────────────────────────────────────────
function GeneratorBadge({ generator }) {
  const cfg = getCfg(generator);
  const cl  = getColors(cfg.color);
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-mono font-bold uppercase tracking-wider ${cl.badge}`}>
      {cfg.badgeText}
    </span>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// SOUS-COMPOSANT : ligne de parcours avec sélecteur de générateur
// ─────────────────────────────────────────────────────────────────────────────
function CourseRow({ course, onGenerate, generating }) {
  /**
   * course = {
   *   userCourseId : string     — ID UserCourse backend
   *   parcoursNom  : string     — nom du parcours
   *   generator    : string     — ex: 'DPCPDF', 'QualiopiPDF'
   *   status       : string     — 'completed' | 'in_progress' | 'not_started'
   *   progress     : number     — 0-100
   *   isCertified  : boolean
   * }
   */
  const cfg    = getCfg(course.generator);
  const cl     = getColors(cfg.color);
  const Icon   = cfg.icon;
  const isLoading = generating === course.userCourseId;

  const statusStyles = {
    completed:   'text-emerald-400',
    in_progress: 'text-amber-400',
    not_started: 'text-zinc-600',
  };
  const statusLabel = {
    completed:   'Terminé',
    in_progress: 'En cours',
    not_started: 'Non démarré',
  };

  return (
    <div className="flex items-center gap-3 px-3 py-2.5 bg-black/30 border border-zinc-800/60 hover:border-zinc-700 transition-colors group">
      {/* Icône générateur */}
      <div className={`w-7 h-7 rounded flex items-center justify-center flex-shrink-0 ${cl.bg} border ${cl.border}`}>
        <Icon size={13} className={cl.icon} />
      </div>

      {/* Parcours info */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-white text-xs font-medium truncate max-w-[180px]">
            {course.parcoursNom || 'Parcours sans titre'}
          </span>
          <GeneratorBadge generator={course.generator} />
          {course.isCertified && (
            <CheckCircle2 size={12} className="text-emerald-400 flex-shrink-0" />
          )}
        </div>
        {/* Barre de progression */}
        <div className="flex items-center gap-2 mt-1">
          <div className="flex-1 h-1 bg-zinc-800 rounded-full overflow-hidden max-w-[100px]">
            <div
              className={`h-full rounded-full transition-all ${
                course.status === 'completed' ? 'bg-emerald-500' :
                course.status === 'in_progress' ? 'bg-amber-500' : 'bg-zinc-700'
              }`}
              style={{ width: `${course.progress ?? 0}%` }}
            />
          </div>
          <span className={`text-[10px] font-mono flex-shrink-0 ${statusStyles[course.status] || 'text-zinc-600'}`}>
            {statusLabel[course.status] || '—'} · {course.progress ?? 0}%
          </span>
        </div>
      </div>

      {/* Bouton générer */}
      <button
        onClick={() => onGenerate(course.userCourseId, course.generator)}
        disabled={!course.userCourseId || isLoading}
        className={`flex items-center gap-1.5 px-3 py-1.5 text-[11px] font-medium border rounded transition-all flex-shrink-0 ${
          course.userCourseId && !isLoading
            ? `${cl.btn} border`
            : 'bg-zinc-800 border-zinc-700 text-zinc-600 cursor-not-allowed'
        }`}
      >
        {isLoading ? (
          <span className="w-3 h-3 border border-current border-t-transparent rounded-full animate-spin" />
        ) : (
          <Download size={11} />
        )}
        {isLoading ? 'Génération…' : 'Relevé'}
      </button>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// SOUS-COMPOSANT : ligne apprenant expandable → liste de ses parcours
// ─────────────────────────────────────────────────────────────────────────────
function LearnerRow({ learner, onGenerate, generating, defaultColor }) {
  const [expanded, setExpanded] = useState(false);
  const cl = getColors(defaultColor);

  /**
   * learner.courses = [{
   *   userCourseId, parcoursNom, generator, status, progress, isCertified
   * }]
   * Si absent ou [], on tente l'ancien format learner.activeCourse pour compat.
   */
  const courses = useMemo(() => {
    if (Array.isArray(learner.courses) && learner.courses.length > 0) {
      return learner.courses;
    }
    // Compat descendante : activeCourse singulier
    if (learner.activeCourse?.userCourseId) {
      return [{
        userCourseId: learner.activeCourse.userCourseId,
        parcoursNom:  learner.activeCourse.parcoursNom || 'Parcours actif',
        generator:    learner.activeCourse.generator   || 'QualiopiPDF',
        status:       learner.activeCourse.status      || 'in_progress',
        progress:     learner.activeCourse.progress    || 0,
        isCertified:  learner.activeCourse.isCertified || false,
      }];
    }
    return [];
  }, [learner]);

  const hasCourses = courses.length > 0;
  const certifiedCount = courses.filter(c => c.isCertified).length;

  return (
    <div className="border border-zinc-800/60 hover:border-zinc-700 transition-colors">
      {/* Ligne principale apprenant */}
      <div
        className={`flex items-center gap-3 px-3 py-2.5 cursor-pointer select-none ${hasCourses ? 'hover:bg-zinc-900/40' : ''}`}
        onClick={() => hasCourses && setExpanded(v => !v)}
      >
        {/* Chevron */}
        <div className="w-4 flex-shrink-0">
          {hasCourses
            ? expanded
              ? <ChevronDown size={12} className="text-zinc-500" />
              : <ChevronRight size={12} className="text-zinc-500" />
            : <span className="w-3 h-3 block" />}
        </div>

        {/* Dot statut */}
        <div className={`w-2 h-2 rounded-full flex-shrink-0 ${cl.dot}`} />

        {/* Identité */}
        <div className="flex-1 min-w-0">
          <span className="text-white text-sm truncate block">
            {learner.firstName} {learner.lastName}
          </span>
          <span className="text-zinc-500 text-[10px] truncate hidden sm:block">
            {learner.email}
          </span>
        </div>

        {/* Compteurs */}
        <div className="flex items-center gap-2 flex-shrink-0">
          {courses.length > 0 && (
            <span className="text-[10px] font-mono text-zinc-500">
              {courses.length} parcours
            </span>
          )}
          {certifiedCount > 0 && (
            <span className="flex items-center gap-1 text-[10px] text-emerald-400 font-mono">
              <CheckCircle2 size={10} />
              {certifiedCount}
            </span>
          )}
          {!hasCourses && (
            <span className="text-[10px] text-zinc-600 italic">Aucun parcours</span>
          )}
        </div>
      </div>

      {/* Parcours dépliés */}
      {expanded && hasCourses && (
        <div className="px-3 pb-2 space-y-1 bg-black/20 border-t border-zinc-800/40">
          {courses.map(course => (
            <CourseRow
              key={course.userCourseId}
              course={course}
              onGenerate={onGenerate}
              generating={generating}
            />
          ))}
        </div>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT PRINCIPAL
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Props :
 *   qualiData      object   — données du dashboard (from getDashboardData)
 *   qualiLoading   bool
 *   qualiError     string|null
 *   generator      string   — clé PDF_GENERATORS du tenant (ex: 'DPCPDF')
 *   learners       array    — apprenants avec learner.courses[] (voir LearnerRow)
 *   generateReleve (userCourseId, generator?) => void
 *   tenantId       string
 */
export default function CertificationDashboard({
  qualiData,
  qualiLoading,
  qualiError,
  generator,
  learners = [],
  generateReleve,
  tenantId,
}) {
  const cfg    = getCfg(generator);
  const cl     = getColors(cfg.color);
  const Icon   = cfg.icon;

  const [showLearners, setShowLearners]   = useState(false);
  const [generating,   setGenerating]     = useState(null); // userCourseId en cours
  const [genError,     setGenError]       = useState(null);
  const [search,       setSearch]         = useState('');

  // Filtre apprenant par nom / email
  const filteredLearners = useMemo(() => {
    if (!search.trim()) return learners;
    const q = search.toLowerCase();
    return learners.filter(l =>
      `${l.firstName} ${l.lastName} ${l.email}`.toLowerCase().includes(q)
    );
  }, [learners, search]);

  // Stats rapides liste
  const totalCourses    = useMemo(() => learners.reduce((acc, l) => acc + (l.courses?.length ?? (l.activeCourse ? 1 : 0)), 0), [learners]);
  const totalCertified  = useMemo(() => learners.reduce((acc, l) => {
    const courses = l.courses || (l.activeCourse ? [l.activeCourse] : []);
    return acc + courses.filter(c => c.isCertified).length;
  }, 0), [learners]);

  async function handleGenerate(userCourseId, courseGenerator) {
    if (!userCourseId) return;
    setGenError(null);
    setGenerating(userCourseId);
    try {
      await generateReleve(userCourseId, courseGenerator);
    } catch (err) {
      setGenError(`Erreur : ${err?.message || 'génération échouée'}`);
    } finally {
      setGenerating(null);
    }
  }

  // ── États de chargement / erreur ────────────────────────────────────────────
  if (qualiLoading) {
    return (
      <div className={`border ${cl.border} bg-black/40 overflow-hidden`}>
        <div className={`px-5 py-3 border-b border-zinc-800 ${cl.bg}`}>
          <div className="flex items-center gap-2.5">
            <Icon size={16} className={cl.icon} />
            <span className={`text-xs font-black uppercase tracking-wider ${cl.text}`}>
              Chargement indicateurs…
            </span>
          </div>
        </div>
        <div className="p-6 space-y-2 animate-pulse">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-4 bg-zinc-800 rounded" style={{ width: `${80 - i * 15}%` }} />
          ))}
        </div>
      </div>
    );
  }

  if (qualiError) {
    return (
      <div className={`border ${cl.border} bg-black/40 overflow-hidden`}>
        <div className="px-5 py-3 border-b border-zinc-800 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <AlertTriangle size={16} className="text-red-400" />
            <span className={`text-xs font-black uppercase tracking-wider ${cl.text}`}>
              {cfg.label}
            </span>
          </div>
          <span className="text-[10px] text-red-400 font-mono">Erreur de chargement</span>
        </div>
        <div className="px-5 py-3 bg-red-950/20 text-red-400 text-sm border-b border-red-800/40">
          {qualiError}
        </div>
      </div>
    );
  }

  const metrics = qualiData ? cfg.metrics(qualiData) : [];

  return (
    <div className={`border ${cl.border} bg-black/40 overflow-hidden`}>

      {/* ── En-tête ─────────────────────────────────────────────────────────── */}
      <div className={`px-5 py-3 border-b border-zinc-800 flex items-center justify-between ${cl.bg}`}>
        <div className="flex items-center gap-2.5">
          <Icon size={16} className={cl.icon} />
          <span className={`text-xs font-black uppercase tracking-wider ${cl.text}`}>
            {cfg.label} — Certifications & Relevés
          </span>
          <GeneratorBadge generator={generator} />
          {tenantId && (
            <span className="text-[10px] text-zinc-600 font-mono hidden sm:inline">{tenantId}</span>
          )}
        </div>
        {qualiData && (
          <span className="text-[10px] text-zinc-600 font-mono">
            {new Date().toLocaleDateString('fr-FR')}
          </span>
        )}
      </div>

      {/* ── Métriques ───────────────────────────────────────────────────────── */}
      {metrics.length > 0 && (
        <div className="p-5 border-b border-zinc-800">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {metrics.map((m, idx) => (
              <div key={idx} className="border border-zinc-800 bg-black/40 p-4">
                <div className="flex items-center gap-2 mb-2">
                  <m.icon size={14} className={cl.icon} />
                  <span className="text-[10px] uppercase text-zinc-500 tracking-wide">{m.label}</span>
                </div>
                <div className={`text-2xl font-black font-mono ${cl.icon}`}>{m.value}</div>
                <div className="text-[11px] text-zinc-600 mt-0.5">{m.sub}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── Erreur de génération ─────────────────────────────────────────────── */}
      {genError && (
        <div className="px-5 py-2 bg-red-950/30 border-b border-red-900/40 flex items-center gap-2">
          <AlertTriangle size={12} className="text-red-400 flex-shrink-0" />
          <span className="text-xs text-red-400">{genError}</span>
          <button onClick={() => setGenError(null)} className="ml-auto text-[10px] text-zinc-500 hover:text-zinc-300">
            ✕
          </button>
        </div>
      )}

      {/* ── Section relevés individuels ──────────────────────────────────────── */}
      <div className="bg-zinc-900/40">

        {/* Barre d'en-tête section */}
        <div className="px-5 py-3 flex items-center justify-between border-b border-zinc-800/60">
          <div className="flex items-center gap-2.5">
            <Download size={14} className={cl.icon} />
            <span className="text-xs font-bold text-zinc-300">Relevés individuels</span>
            <span className="text-[10px] font-mono text-zinc-600 bg-zinc-800 px-2 py-0.5 rounded-full">
              {learners.length} apprenants
            </span>
            {totalCourses > 0 && (
              <span className="text-[10px] font-mono text-zinc-600 bg-zinc-800 px-2 py-0.5 rounded-full hidden sm:inline">
                {totalCourses} parcours
              </span>
            )}
            {totalCertified > 0 && (
              <span className="flex items-center gap-1 text-[10px] font-mono text-emerald-500 bg-emerald-950/40 border border-emerald-900/50 px-2 py-0.5 rounded-full">
                <CheckCircle2 size={9} />
                {totalCertified} certifiés
              </span>
            )}
          </div>
          <button
            onClick={() => setShowLearners(v => !v)}
            className="flex items-center gap-1 text-xs text-zinc-400 hover:text-zinc-200 transition-colors"
          >
            {showLearners ? 'Masquer' : 'Afficher'}
            {showLearners
              ? <ChevronDown size={12} />
              : <ChevronRight size={12} />}
          </button>
        </div>

        {/* Liste ─────────────────────────────────────────────────────────────── */}
        {showLearners && (
          <div className="px-5 py-3 space-y-2">

            {/* Recherche */}
            {learners.length > 5 && (
              <input
                type="text"
                placeholder="Rechercher un apprenant…"
                value={search}
                onChange={e => setSearch(e.target.value)}
                className="w-full bg-black/40 border border-zinc-800 text-zinc-300 text-xs px-3 py-2 placeholder-zinc-600 focus:outline-none focus:border-zinc-600 rounded"
              />
            )}

            {/* Légende des générateurs présents */}
            {(() => {
              const gens = [...new Set(
                learners.flatMap(l =>
                  (l.courses || (l.activeCourse ? [l.activeCourse] : []))
                    .map(c => c.generator)
                    .filter(Boolean)
                )
              )];
              if (gens.length <= 1) return null;
              return (
                <div className="flex flex-wrap gap-1.5 pb-1">
                  {gens.map(g => (
                    <div key={g} className="flex items-center gap-1">
                      <GeneratorBadge generator={g} />
                      <span className="text-[10px] text-zinc-500">{getCfg(g).label}</span>
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* Lignes apprenants */}
            <div className="max-h-80 overflow-y-auto space-y-1 pr-1">
              {filteredLearners.length === 0 ? (
                <p className="text-zinc-600 text-xs py-3 text-center">
                  {search ? 'Aucun résultat pour cette recherche.' : 'Aucun apprenant.'}
                </p>
              ) : (
                filteredLearners.map(learner => (
                  <LearnerRow
                    key={learner._id}
                    learner={learner}
                    onGenerate={handleGenerate}
                    generating={generating}
                    defaultColor={cfg.color}
                  />
                ))
              )}
            </div>

            {/* Note multi-générateurs */}
            {totalCourses > learners.length && (
              <p className="text-[10px] text-zinc-600 pt-1 border-t border-zinc-800/40">
                Certains apprenants ont plusieurs parcours actifs — chaque relevé est généré
                selon son référentiel (Qualiopi, DPC, AFDAS…).
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}